(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function loadSources(v) {
    if (v.__brandSrcLoaded) return;
    v.__brandSrcLoaded = true;
    var srcs = v.querySelectorAll('source[data-src]');
    if (!srcs.length) return;
    for (var i = 0; i < srcs.length; i++) {
      srcs[i].setAttribute('src', srcs[i].getAttribute('data-src'));
      srcs[i].removeAttribute('data-src');
    }
    v.load();
  }

  function setup(v) {
    if (v.__brandVideoInit) return;
    v.__brandVideoInit = true;

    v.muted = true;
    v.defaultMuted = true;
    v.setAttribute('muted', '');
    v.volume = 0;

    if (reduce) {
      v.removeAttribute('autoplay');
      return;
    }

    var bound = false;
    var gestureEvents = ['touchstart', 'pointerdown', 'click', 'scroll', 'keydown'];

    function onGesture() {
      gestureEvents.forEach(function (e) {
        window.removeEventListener(e, onGesture, true);
      });
      bound = false;
      attempt();
    }

    function bindGesture() {
      if (bound) return;
      bound = true;
      gestureEvents.forEach(function (e) {
        window.addEventListener(e, onGesture, { capture: true, passive: true });
      });
    }

    function attempt() {
      if (!v.paused && !v.ended) return;
      loadSources(v);
      v.muted = true;
      var p;
      try {
        p = v.play();
      } catch (e) {
        bindGesture();
        return;
      }
      if (p && typeof p.then === 'function') {
        p.then(function () {
          bound = false;
        }).catch(function () {
          bindGesture();
        });
      }
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            attempt();
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { threshold: 0.01, rootMargin: '800px 0px' });
      io.observe(v);
    } else {
      attempt();
    }

    v.addEventListener('canplay', attempt, { once: false });
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var list = scope.querySelectorAll('video[data-brand-video]');
    for (var i = 0; i < list.length; i++) setup(list[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
